import { isEqual } from 'lodash';

// Deliberately typed against plain Record<string, unknown> rather than a
// shared generic <T>: callers diff a full store snapshot (`get()` / `state`)
// against `savedBaseline`, which is stored as `Record<string, unknown>` and
// isn't the same concrete type as the store itself — forcing both through one
// generic type parameter would fail to unify. Both IoSettingsStore and
// LineItemStore (and the plain preview `state`) are structurally compatible
// with Record<string, unknown> for this read-only comparison.
export const countChangedFields = (
  current: Record<string, unknown>,
  baseline: Record<string, unknown>,
  fields: readonly string[]
): number => fields.filter(field => !isEqual(current[field], baseline[field])).length;

// Main Settings isn't a hand-picked positive list: it's each store's own
// TRACKED_FIELDS minus whatever belongs to Context & Targeting, Creatives,
// or the map (uncounted everywhere) — see `MAIN_SETTINGS_FIELDS` derived from
// this in each store, since IO and LI don't share an identical field list.
export const MAIN_SETTINGS_EXCLUDED_FIELDS = [
  '_id',
  'ads',
  'contextualBidding',
  'targeting',
  'dco',
  'zoneGroups',
  'screenGroups'
] as const;

export const CONTEXT_TARGETING_FIELDS = ['contextualBidding', 'targeting'] as const;

export const CREATIVES_OTHER_FIELDS = ['dco'] as const;
